import React from "react";
import okImg from "../../../assets/images/okImg.png";
import zoomImg from "../../../assets/images/pngwing.com 1.png";
import { MdOutlineEmail } from "react-icons/md";
import { BsTelephone } from "react-icons/bs";
import colorImg from "../../../assets/images/colour.png";
import "./Footer.css";
export function Footer(){   
    return(
           <div className="container">
    <div className="footerContainer">
      <div>
        <div><BsTelephone/>&nbsp; Info.Occultking@gmail.com</div>
        <div>< MdOutlineEmail />&nbsp; +91 9157591373</div>
      </div>
      <div style={{ display: "flex" }}>
        <div className="bi bi-geo-alt"></div>&nbsp;
        <div>
          Fortune Murali Park, Islampet, Vijayawada, Coastal Andhra, Andhra
          Pradesh, India
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        <div className="okImg">
          <img src={colorImg} />
        </div>
        {/* &nbsp;
        <div>
          <div>Arihant Raaj</div>
          <div>Vastu Astro Numero Expert</div>
        </div> */}
      </div>
    </div>
    </div>
    )
}